import { present } from './components/public/Dialog/generic/utilities';

// Create a random number to use as a unique id when creating new entities
export const randomNumber = () =>
  Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);

export function presentValueOr(
  value: number | null | undefined,
  defaultValue: number
): number {
  return present(value) ? value : defaultValue;
}
